module.exports = __webpack_public_path__ + "img/1-draw.b6f5701c.png";